import { BaseBean } from "./BaseBean";
import { LenguaBean } from "./LenguaBean";


export class VarianteLenguaBean extends BaseBean{

  public id:number;
  public lengua:LenguaBean;
  public nombre:string;

}
